import { render, staticRenderFns } from "./Forgotpassword.vue?vue&type=template&id=22f3442d&"
import script from "./Forgotpassword.vue?vue&type=script&lang=js&"
export * from "./Forgotpassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports